import * as React from 'react';

import { Route, Routes } from 'react-router-dom';

import PickupModeModal from 'components/pickup-mode-modal';
import { relativeRoutes } from 'utils/routing';

interface IPickUpRoutesProps {
  redirectUrl: string;
}

export const PickUpRoutes: React.VFC<IPickUpRoutesProps> = ({ redirectUrl }) => {
  return (
    <Routes>
      {/* Used in global store card */}
      <Route
        path={relativeRoutes.pickupMode}
        element={<PickupModeModal redirectUrl={redirectUrl} />}
      />
    </Routes>
  );
};
